import { LinksType } from 'utils/api/types';

/**
 * Finds a link by entity type from an array of links.
 * @param links - Array of links to search through, can be undefined or null
 * @param entity - The entity type to search for (e.g., 'inspection', 'sites', 'assets', 'contacts')
 * @returns The link matching the entity type if found, undefined otherwise
 */
export const findLinkByEntity = (links: LinksType[] | undefined | null, entity: string): LinksType | undefined => {
  if (!links) {
    return undefined;
  }
  return links.find((link) => link.entity === entity);
};
